/* eslint-disable linebreak-style */
define('AwaLabs.AutoSlider', [
    'SC.Configuration',
    'Backbone',
    'jQuery',
    'underscore'
], function AwaLabsAutoSlider(
    Configuration,
    Backbone,
    jQuery,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            container.getLayout().once('beforeAppendView', function beforeAppendView() {
                CMS.on('page:content:set', function initSlider() {
                    _.defer(function onDefer() {
                        var currentView = container.getLayout().currentView; // eslint-disable-line no-underscore-dangle
                        var $sliders = (currentView && currentView.$('[data-autoslider]')) || [];
                        var options = Configuration.bxSliderDefaults;
                        _.each($sliders, function eachSlider(slider) {
                            var $slider = jQuery(slider);
                            try {
                                options = $slider.data('autoslideroptions');
                            } catch (e) {
                                console.log(e);
                            }
                            $slider.bxSlider(options);
                        });
                    });
                });
            })
        }
    };
});
